module.exports = __webpack_public_path__ + "assets/edit1.98f3c41c4d3767ed5be42bc9dc0da170.png";